import "./header.css";
import logo from "../../assets/imgs/navbar/logo_azul.png";
import gcp from "../../assets/imgs/navbar/gcp.png";
import { FaAngleUp, FaBars } from "react-icons/fa6";
import { useState, useEffect, useRef } from "react";
import { useContext } from "react";
import { MenuContext } from "../../views/dashboard/admin/admin"; 
import DataTable from "../../views/home/data-table/data-table";

function Header() {
    const [statusWeek, setStatusWeek] = useState(false);
    const [statusYear, setStatusYear] = useState(false);
    const [detailsComponents, setDetailsComponents] = useState(false);
    const [txtStatusWeek, setTxtStatusWeek] = useState('');
    const [txtStatusYear, setTxtStatusYear] = useState('');
    const [statusUpdate, setStatusUpdate] = useState(false);
    const linkRef = useRef(null);
    const [params, setParams] = useState({ week: '', year: '' });

    const handleMenuClick = useContext(MenuContext);
    const selectWeek = () => {
        setStatusYear(false);
        setDetailsComponents(false);
        setStatusWeek(!statusWeek);
    }
    const chooseOptionWeek = (option) => {
        setStatusWeek(!statusWeek);
        setTxtStatusWeek(option);
    }
    const selectYear = () => {
        setStatusWeek(false);
        setDetailsComponents(false);
        setStatusYear(!statusYear);
    }
    const chooseOptionYear = (option) => {
        setStatusYear(!statusYear);
        setTxtStatusYear(option)
    }

    const showDetailsComponents = () => {
        setStatusYear(false);
        setStatusWeek(false);
        setDetailsComponents(!detailsComponents);
    }
 
    const empezarBusqueda = () => {
        const sanitizedWeek = parseInt(txtStatusWeek, 10);
        const sanitizedYear = parseInt(txtStatusYear, 10);
        
        // Verifica que ambos sean números válidos antes de actualizar el href
        if (!isNaN(sanitizedWeek) && !isNaN(sanitizedYear)) {
            let newURL = `?week=${sanitizedWeek}&year=${sanitizedYear}`;
            window.history.replaceState(null, "", newURL);
            if(statusUpdate){
                setStatusUpdate(false);
            }else{
                setStatusUpdate(true)
            }
        }
    };

    useEffect(() => {
        // Obtener la URL actual
        const searchParams = new URLSearchParams(window.location.search);

        // Obtener los parámetros de la URL
        const week = searchParams.get('week');
        const year = searchParams.get('year');

        // Actualizar el estado si los parámetros existen
        if (week) {
            setParams(prevParams => ({ ...prevParams, week }));
        }
        if (year) {
            setParams(prevParams => ({ ...prevParams, year }));
        } 

        setTxtStatusWeek(week);
        setTxtStatusYear(year);
        setStatusYear(false);
        setStatusWeek(false);
    }, []);
    


    return (
        <div>
            <div className="header-container">
            <div className="img-cont">
                <img className="amc-cargo-logo" src={logo} alt="logo amc" />
            </div>
            <div className="img-cont">
                <img className="gcp-logo" src={gcp} alt="gcp logo" />
            </div>
            <div className="img-cont">
                <p className="cfdi-txt">CFDI 4.0</p>
            </div>
            <div className="header-form-container">
                <form className="header-form">

                    <div className="form-group-header">
                        <label>Semana</label>
                        <div className="select-menu">
                            <div className="select-btn" onClick={selectWeek}>
                                <span className="btn-txt-default">{ txtStatusWeek }</span>
                                <i className={statusWeek ? "icon-down" : "icon-up"}><FaAngleUp /></i>
                            </div>
                            {statusWeek && (
                                <ul className="select-options bg-gradient-blue">
                                    {[...Array(52).keys()].map((index) => {
                                        const value = index + 1 < 10 ? `0${index + 1}` : `${index + 1}`;
                                        return (
                                            <li
                                                key={`option${value}`}
                                                className="option"
                                                value={value}
                                                onClick={() => chooseOptionWeek(value)}
                                            >
                                                {value}
                                            </li>
                                        );
                                    })}
                                </ul>
                                
                            )}
                        </div>
                    </div>

                    <div className="form-group-header">
                        <label>Año</label>
                        <div className="select-menu">
                            <div className="select-btn" onClick={selectYear}>
                                <span className="btn-txt-default">{ txtStatusYear }</span>
                                <i className={statusYear ? "icon-down" : "icon-up"}><FaAngleUp /></i>
                            </div>
                            {statusYear && (
                                <ul className="select-options bg-gradient-blue">
                                    {Array.from({ length: new Date().getFullYear() - 2023 + 1 }, (_, i) => 2023 + i).map((year) => (
                                        <li key={year} className="option" onClick={() => chooseOptionYear(year.toString())}>
                                            {year}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>


                    <div className="btn-amc-blue header-btn-search d-flex align-elements-center justify-content-center p-1 c-pointer" onClick={empezarBusqueda}>
                        Buscar
                    </div>
                    <div className="details-consulting">
                        <button className="btn-amc-blue btn-consulting-mb" type="button" onClick={showDetailsComponents}>
                            <div style={{marginRight: "5px"}}>
                                <FaBars />    
                            </div> 
                            Consultar detalle
                        </button>
                        { detailsComponents && (
                            <div className="details-consulting-options bg-gradient-blue">
                                <p onClick={() => handleMenuClick("DashDetalles")}><span className="text-decoration-none text-white">Detalles</span></p>
                                <p onClick={() => handleMenuClick("DashVuelosOperados")}><span className="text-decoration-none text-white">Detalles vuelos operados</span></p>
                                <p onClick={() => handleMenuClick("DashVuelosFacturados")}><span className="text-decoration-none text-white">Detalles vuelos facturados</span></p>
                                <p onClick={() => handleMenuClick("DashVuelosNoFacturados")}><span className="text-decoration-none text-white">Detalles vuelos no facturados</span></p>
                            </div>
                        )}
                    </div>
                    {/*
                    {localStorage.getItem('admin_permission') === '1' && (*/}
                        <button className="btn-amc-blue header-btn-search d-flex align-elements-center justify-content-center p-1" onClick={() => handleMenuClick("Bienvenido")}>
                            Administrador
                        </button>
                    {/*)}*/}

                  
                </form>
            </div>
            </div>
            <DataTable />
        </div>
    )
}

export default Header;